/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL2Zvcm0tYnVpbGRlci9jb21wb25lbnRzL2RpYWxvZy1maWVsZC9kaWFsb2ctZmllbGQuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmFyL3d3dy9kbmF0YS1jZXJmLWZyb250LWVuZC9yZWxlYXNlcy8yMDIwMDMyNjE2MTIzMy9zcmMvYXBwL21vZHVsZXMvZm9ybS1idWlsZGVyL2NvbXBvbmVudHMvZGlhbG9nLWZpZWxkL2RpYWxvZy1maWVsZC5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/form-builder/components/dialog-field/dialog-field.component.scss.shim.ngstyle.ts